<template>
  <button class="button" type="button" name="button" v-on="listeners">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'CiButton',
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        click: event => this.clickButton(event),
        blur: event => this.blurButton(event),
        mouseover: event => this.mouseoverx(event),
        mouseout: event => this.mouseoutx(event),
      }
    },
  },
  methods: {
    clickButton(event) {
      this.$emit('click', event)
    },
    mouseoverx(event) {
      this.$emit('mouseover', event)
    },
    mouseoutx(event) {
      this.$emit('mouseout', event)
    },
    blurButton(event) {
      this.$emit('blur', event)
    },
  },
}
</script>

<style lang="scss" scoped>
.button {
  position: relative;
  display: flex;
  align-items: center;
  -moz-osx-font-smoothing: inherit;
  -webkit-font-smoothing: inherit;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: 37.5px;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  font: inherit;
  line-height: normal;
  margin: 0 0 10px 0;
  overflow: visible;
  padding: 0 60px;
  width: auto;
  justify-content: center;

  @include media-breakpoint-up(md) {
    padding: 0 60px;
    margin: 0;
  }

  .icon {
    left: 20px;
    position: absolute;
    top: 50%;
    transform: translate3d(0, -50%, 0);

    &.icon--animated {
      transition: transform 0.3s ease;
    }
  }

  .no-touch &:hover {
    .icon--animated {
      transform: translate3d(-5px, -50%, 0);
    }

    span + .icon--animated {
      transform: translate3d(5px, -50%, 0);
    }
  }

  span + .icon {
    left: auto;
    right: 20px;
  }

  &.button--small {
    height: 40px;
  }

  &.button--no-border {
    border: 2px solid transparent;
  }
}

.button--primary {
  height: 45px;
  color: white;
  background: $primary-orange;
  border: 2px solid $primary-orange;
}

.button--secondary {
  height: 36px;
  padding: 0 50px;
  border: 2px solid grey;
}

.button--tertiary {
  height: 45px;
  color: white;
  background: $primary-orange;
  border: 2px solid $primary-orange;
}

.button--tertiary-outline {
  @include font-format(0.875rem, 1.125rem);

  border: 2px solid $primary-orange;
  padding: 0 40px;
  height: 45px;
}

.button--primary-outline {
  @include font-format(0.875rem, 1.125rem);

  border: 2px solid $primary-orange;
  padding: 0 40px;
  height: 45px;
}

.button[disabled] {
  cursor: not-allowed;
  background: #9b9b9b;
  border-color: transparent;

  .no-touch &:hover {
    .icon--animated {
      transform: translate3d(0, -50%, 0);
    }
  }
}
</style>
